import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.scss']
})
export class MultiSelectDropdownComponent implements OnInit {  
  @Input() list:any[] = [];
  @Input() title: string = ""; 
  @Input() checkedItems: number[];
  @Output() shareCheckedList = new EventEmitter();  
  
  checkedList: any[];
  checkedListObj: any[];

  constructor() {
    this.checkedList = [];
    this.checkedListObj = [];
  }

  ngOnInit(): void {
    this.checkIfPopulated();
    this.shareCheckedlist();
  }

  checkIfPopulated() {
    if (this.checkedItems) {
      this.list.map((item) => {
        this.checkedItems.map((id) => {
          if (item.id == id) {
            this.checkedList.push(item.id);
          }
        })
      });
    }
  }

  shareCheckedlist() {
    this.shareCheckedList.emit(this.checkedList);
  }
}
